import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import AssetReferencesLayer from '../components/AssetReferencesLayer';

const AssetReferencesPage = () => (
  <MasterLayout pageTitle='Asset Reference Tables'>
    <AssetReferencesLayer />
  </MasterLayout>
);

export default AssetReferencesPage;
